export interface TabPersistenceConfig {
  paramName: string;
  defaultTab?: string;
  updateHistory?: boolean;
}

export const getTabFromSearch = (
  search: string,
  config: TabPersistenceConfig
): string | undefined => {
  try {
    const params = new URLSearchParams(search);
    return params.get(config.paramName) || config.defaultTab;
  } catch {
    return config.defaultTab;
  }
};

export const buildTabSearch = (
  currentSearch: string,
  config: TabPersistenceConfig,
  tab: string
): string => {
  try {
    const params = new URLSearchParams(currentSearch);
    if (tab === config.defaultTab) {
      params.delete(config.paramName);
    } else {
      params.set(config.paramName, tab);
    }
    const queryString = params.toString();
    return queryString ? `?${queryString}` : '';
  } catch {
    return currentSearch;
  }
};
